<template>
  <b-modal
    id="modal-idade"
    size="md"
    @show="showModalIdade"
    @hidden="resetModalIdade"
  >
    <template v-slot:modal-title>
      <b-form-input
        v-model="grupo.nome"
        :state="grupoState"
        :data-id="id"
        aria-describedby="input-live-help input-live-feedback"
        placeholder="Nome do grupo. Por ex: Diretores ou Funcionários"
        trim
        class="inputModal"
      ></b-form-input>

      <!-- This will only be shown if the preceding input has an invalid state -->
      <b-form-invalid-feedback id="input-live-feedback">
        Informe o nome do grupo
      </b-form-invalid-feedback>
    </template>
    <div class="d-block text-center">
      <div class="row">
        <template v-for="(faixa, i) in grupo.faixas">
          <div class="px-1 pb-2 col" :key="i" v-if="i < 5">
            <div
              :id="`faixa-${faixa.slug}-group`"
              role="group"
              class="form-group">
              <label
                :id="`faixa-${faixa.slug}`"
                :for="`faixa-${faixa.slug}`"
                class="d-block">
                {{ faixa.label }}
              </label>
              <div class="bv-no-focus-ring">
                <input
                  :id="`faixa-${faixa.slug}`"
                  type="number"
                  min="0"
                  max="99"
                  class="form-control"
                  :data-cenarioId="cenarioId"
                  :data-slug="faixa.slug"
                  v-model="faixa.value"
                  @change="updateFaixas">
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="row">
        <template v-for="(faixa, i) in grupo.faixas">
          <div class="px-1 pb-2 col" :key="i" v-if="i >= 5">
            <div
              :id="`faixa-${faixa.slug}-group`"
              role="group"
              class="form-group">
              <label
                :id="`faixa-${faixa.slug}`"
                :for="`faixa-${faixa.slug}`"
                class="d-block">
                {{ faixa.label }}
              </label>
              <div class="bv-no-focus-ring">
                <input
                  :id="`faixa-${faixa.slug}`"
                  type="number"
                  min="0"
                  max="99"
                  class="form-control"
                  :data-cenarioId="cenarioId"
                  :data-slug="faixa.slug"
                  v-model="faixa.value"
                  @change="updateFaixas">
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex">
        <p class="totalVidasP float-left">{{ totalVidas }}</p>
        <b-button
          variant="primary"
          size="xl"
          class="float-right"
          @click="handleOkIdade"
          :disabled="btnDisabled"
          :class="btnDisabled ? 'confirmarOff' : ''">
          Confirmar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import newCenario from "@/data/newCenario";

export default {
  props: ["id"],
  data() {
    return {
      btnDisabled: true,
      grupo: newCenario,
      grupoState: null
    };
  },
  computed: {
    ...mapGetters("share", ["getFiltros"]),
    ...mapGetters('modalFilter', ['getFilters']),
    ...mapGetters("cenario", {
      getId: "getId",
      getCenario: "getCenario",
      getCenarios: "getCenarios",
      faixa: "getFaixaEl"
    }),
    ...mapGetters("plano", {
      grupos: "getAux",
      loadingAux: "getLoading"
    }),
    totalVidas() {
      let soma = this.grupo.faixas
        .map(f => Number(f.value))
        .reduce((o, c) => o + c);
       if(soma === 1) {
         return `Total: ${soma} vida`
       } else {
        return `Total: ${soma} vidas`
       }
    },
    lastId() {
      let id = this.getCenarios.length
        ? this.getCenarios.map(c => c.id).reduce((a, b) => Math.max(a, b))
        : 0
      id++;
      return id
    },
    cenarioId() {
      return this.getId ? this.getId : this.lastId;
    }
  },
  watch: {
    grupo: {
      deep: true,
      handler(grupo) {
        let soma = grupo.faixas
          .map(f => Number(f.value))
          .reduce((o, c) => o + c);
        if (soma > 0) {
          this.btnDisabled = false;
        } else {
          this.btnDisabled = true;
        }
      }
    }
  },
  methods: {
    ...mapActions("share", ["updateFiltros"]),
    ...mapActions('modalFilter', ['load']),
    ...mapActions("cenario", ["updateFaixaEl", "updateCenarios", "recuperaCenario", "atualizaCenarios"]),
    ...mapActions("valores", ["buscaPlano"]),
    updateFaixas(e) {
      console.log('ModalIdade:updateFaixas')
      this.updateFaixaEl(e.target);
    },
    atualizaValores(cenarios) {
      // console.log('atualizando Valores')
      let vm = this,
        isPlano = null,
        cenarioId = null,
        faixaSlug = null;
      console.log(this.faixa)
      if (this.faixa) {
        isPlano = this.faixa.getAttribute("data-plano");
        if (!isPlano) {
          cenarioId = this.faixa.getAttribute("data-cenarioId");
          faixaSlug = this.faixa.getAttribute("data-slug");
        }
        vm.recalcularValores(cenarioId, cenarios);
        this.updateFaixaEl(null)
      }
    },
    async recalcularValores(cenarioId, cenarios) {
      console.log('ModalIdade:recalcularValores');
      let vm = this;
      function totalVidas(cenarios) {
        var grupos_faixas = [];
        cenarios.forEach(cenario => {
          cenario.faixas.forEach(faixa => {
            let key = grupos_faixas.findIndex(gf => gf.slug == faixa.slug)
            if (key != -1) {
              grupos_faixas[key].value = parseInt(grupos_faixas[key].value||0) + parseInt(faixa.value||0);
            } else {
              grupos_faixas.push(JSON.parse(JSON.stringify(faixa)));
            }
          })
        });
        return grupos_faixas
      }
      cenarios.forEach(cenario => {
        if (cenario.operadoras.length > 0) {
          cenario.operadoras.forEach(operadora => {
            operadora.grupos.forEach(grupo => {
              grupo.planos.forEach(async (plano) => {
                await vm.buscaPlano({
                  uf: plano.filtros.cidade.uf,
                  produto: plano.produto.id,
                  tipo_plano: plano.filtros.tipo_plano,
                  contratacao: plano.filtros.contratacao,
                  cidade: plano.filtros.cidade ? plano.filtros.cidade.id : "",
                  compulsorio: plano.filtros.compulsorio == 2 ? "" : plano.filtros.compulsorio == 1 ? "s" : "n",
                  coparticipacao: plano.filtros.coparticipacao == 2 ? "" : plano.filtros.coparticipacao == 1 ? "s" : "n",
                  acomodacao: plano.filtros.acomodacao == 2 ? "" : plano.filtros.acomodacao == 1 ? "a" : "e",
                  regras_aceitacao: plano.filtros.regras_aceitacao ? 's' : 'n',
                  credenciado: plano.filtros.credenciado ? plano.filtros.credenciado.tipo + plano.filtros.credenciado.id : "",
                  entidade: plano.filtros.entidade_profissao?.tipo == 'e' ? plano.filtros.entidade_profissao.value.id : '',
                  profissao: plano.filtros.entidade_profissao?.tipo == 'p' ? plano.filtros.entidade_profissao.value.id : '',
                  administradora: plano.filtros.administradora ? plano.filtros.administradora.id : "",
                  faixas: cenario.faixas ? cenario.faixas : "",
                  grupos_faixas: totalVidas(cenarios),
                  detalhes: "n"
                }).then((grupos) => {
                  grupos.forEach(g => {
                    g.planos.forEach(p => {
                      if (plano.id == p.id) {
                        plano.alertas = p.hasOwnProperty("alertas") ? JSON.parse(JSON.stringify(p.alertas)) : [];
                        plano.calculo = JSON.parse(JSON.stringify(p.calculo));
                      }
                    })
                  });
                })
              });
            })
          });
        }
      });
    },
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, []);
    },
    resetModalIdade() {},
    async showModalIdade() {
      await this.recuperaCenario({ id: this.getId })
      this.grupo = this.getCenario
      console.log(this.grupo)
    },
    handleOkIdade(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmitIdade();
    },
    checkFormValidity() {
      return this.btnDisabled;
    },
    hasOperadoras() {
      let operadoras = this.getCenarios.reduce(function(prev, curr) {
        return [...prev, ...curr.operadoras];
      }, []);
      return operadoras.length > 0;
    },
    handleSubmitIdade() {
      if (this.checkFormValidity()) {
        return;
      }
      this.$nextTick(() => {
        let filtros = this.getFiltros;
        filtros.faixas = this.grupo.faixas
        this.updateFiltros(filtros);
        this.atualizaCenarios({
          id: this.getId,
          cenario: this.grupo
        });
        this.atualizaValores(this.getCenarios);
        this.$bvModal.hide("modal-idade");
        this.load({
          filters: this.getFilters,
          recomendar: [],
          atuacao: [],
          modalidade: [],
          acomodacao: [],
          coparticipacao: [],
          reembolso: [],
          taxas_iof: [],
          informacoes: [],
          hospitais: this.getCenarios,
          valores: [
            "00-18",
            "19-23",
            "24-28",
            "29-33",
            "34-38",
            "39-43",
            "44-48",
            "49-53",
            "54-58",
            "59-+"
          ],
          resumos: []
        });
        if (!this.hasOperadoras()) {
          this.$bvModal.show("modal-operadora");
        }
      });
    }
  }
};
</script>

<style scoped>
.totalVidasP {
  font-weight: 400;
  font-size: 18pt;
}
.confirmarOff {
  background-color: black !important;
  border: none;
}
.confirmarOff:hover {
  background-color: black !important;
}
.inputModal {
  height: 31px;
  background-color: white;
}
</style>
